import { getOptions } from '@shared/commonFunctions';
import { GAP_PRODUCT_TYPE } from '@modules/ContactManager/components/Tabs/components/Deals/components/CheckRequestForm';
import { IGapLoanPaidOffRequestInformation } from '@modules/admin/Tools/shared/interfaces';
import { IPayeeLender } from './CheckerMenu/interfaces';

export type TPayeeOptions = IPayeeLender | IGapLoanPaidOffRequestInformation;

export const LOAN_PAID_OFF = 'loanpaidoff';

export function getFormattedPayeeOptions(
  payeeData: IPayeeLender[],
  productType?: string,
  reason?: string
) {
  let baseOptions: TPayeeOptions[] = [...payeeData];

  const isGapLoanPaidOff =
    productType?.toLowerCase() === GAP_PRODUCT_TYPE.toLowerCase() &&
    reason?.toLowerCase() === LOAN_PAID_OFF;

  if (isGapLoanPaidOff) {
    const paidOffEntries = payeeData.flatMap((p) => p.gapLoanPaidOffRequestInformation ?? []);
    const formatted = paidOffEntries.map((e) => ({
      payeeName: e.payeeName,
      payeeAddress: e.payeeAddress,
      payeeState: e.payeeState,
      payeeZip: e.payeeZip,
    }));
    baseOptions = [...baseOptions, ...formatted];
  }

  return getOptions(baseOptions, 'payeeName', 'payeeName');
}